import { ConstructorArgs } from '../types/models'
import { BaseRecord } from './BaseRecord'
import { Conflict, ConflictConstructorArgs } from './Conflict'
import { Requirement } from './Requirement'
import { Resource } from './Resource'
import { User } from './User'

export type StaffingConstructorArgs = Omit<ConstructorArgs<() => Staffing>, 'conflicts'> & {
    conflicts: Conflict[] | ConflictConstructorArgs[] | null
}

export class Staffing extends BaseRecord {
    readonly recordType = 'staffing'

    available: boolean = false
    conflicts: Conflict[] = []

    constructor(data?: Partial<StaffingConstructorArgs>) {
        super(data)
        if (!data) {
            return
        }

        this.available = data.available ?? false
        this.conflicts = (data.conflicts ?? []).map((data) =>
            data instanceof Conflict ? data : new Conflict(data)
        )
    }

    clone(overrides?: Partial<StaffingConstructorArgs>): Staffing {
        return new Staffing({ ...this.serializeForClone(), ...overrides })
    }

    get person(): User | undefined {
        return this.getForeignRecord('person', User)
    }
    set person(person: User | undefined) {
        this.setForeignRecord('person', person)
    }
    get resource(): Resource | undefined {
        return this.getForeignRecord('resource', Resource)
    }
    set resource(resource: Resource | undefined) {
        this.setForeignRecord('resource', resource)
    }
    get autoAssignedRequirement(): Requirement | undefined {
        return this.getForeignRecord('auto_assigned_requirement', Requirement)
    }
    set autoAssignedRequirement(autoAssignedRequirement: Requirement | undefined) {
        this.setForeignRecord('auto_assigned_requirement', autoAssignedRequirement)
    }
}
